<template>
  <div class>
    <div class="ph-item">
      <div>
        <div class="ph-row">
          <div class="ph-col-12"></div>
          <div class="ph-col-2"></div>
          <div class="ph-col-10 empty"></div>
          <div class="ph-col-8 big"></div>
          <div class="ph-col-4 big empty"></div>
        </div>
      </div>
    </div>

    <div class="ph-item">
      <div>
        <div class="ph-row">
          <div class="ph-col-12"></div>
          <div class="ph-col-2"></div>
          <div class="ph-col-10 empty"></div>
          <div class="ph-col-8 big"></div>
          <div class="ph-col-4 big empty"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "paginacao-placeholder"
};
</script>